import BreadCrumb from "Common/BreadCrumb";
import { BasicButton, SelectComponent, SelectSessionValidation } from "Common/Components";
import DeleteModal from "Common/DeleteModal";
import TableContainer from "Common/TableContainer";
import { Plus } from "lucide-react";
import { useEmployeList } from "../hooks";
import { ModalEmploye } from "../components";

export const EmployeList = () => {
  const {
    columns,
    departament,
    setDepartament,
    setIsOpenModal,
    setModalDelete,
    modalDelete,
    deleteDepartament,
    t,
    isSubmiting,
    setBranchSelected,
    setFilterStatus,
    filterStatus,
    session

  } = useEmployeList();
  

  return (
    <>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb
          title={t("createEmploye.titleListPage")}
          pageTitle={t("menu.departament")}
        />
        <div className="card">
          <div className="card-body">
          <div className="flex w-full items-center justify-between flex-wrap">
              <SelectSessionValidation
                classname="w-full sm:w-1/2"
                onChangeCompanie={() => {}}
                onChangeBranch={(option) => {
                  if (option.value === undefined) return;

                  setBranchSelected(option.value);
                }}
                valueCompanie={
                  session?.employe != null
                    ? session?.employe.branch.company.id.toString()
                    : ""
                }
              ></SelectSessionValidation>
              <div className="w-1/4 max-[425px]:w-full">
                <SelectComponent
                  label={t("createEmploye.filterStatusLabel")}
                  id="filterStatus"
                  placeholder={t("selectComponent.defaultValue")}
                  onChange={(option) => {
                    setFilterStatus(option as any);
                  }}
                  value={filterStatus}
                  defaultValue={{
                    label: t("createEmploye.status.all"),
                    value: "null",
                  }}
                  options={[
                    { label: t("createEmploye.status.all"), value: "null" },
                    { label: t("createEmploye.status.pending"), value: "1" },
                    { label: t("createEmploye.status.active"), value: "2" },
                    { label: t("createEmploye.status.bloqued"), value: "3" },
                   
                    
                  ]}
                ></SelectComponent>
              </div>
              <div className="mt-4">
                <BasicButton
                  onClick={() => {
                    setIsOpenModal(true);
                    setDepartament(null);
                  }}
                  type="button"
                >
                  <div className="flex flex-row justify-center items-center">
                    <Plus size={16} color="#fff" />
                    <span className="ml-2 text-slate-50">
                      {t("createEmploye.addNewEmployeBtn")}
                    </span>
                  </div>
                </BasicButton>
              </div>  
            </div>
            <div className="w-full pt-6">
              <TableContainer
                isPagination={true}
                columns={columns || []}
                data={departament || []}
                isTfoot={false}
                isSelect={true}
                isGlobalFilter={true}
                divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
                tableclassName="display stripe group dataTable w-full text-sm align-middle whitespace-nowrap"
                theadclassName="border-b border-slate-200 dark:border-zink-500"
                thclassName="ltr:!text-left rtl:!text-right p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500 sorting_asc"
                tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              ></TableContainer>
            </div>

            <DeleteModal
              show={modalDelete}
              onHide={()=>{setModalDelete(false)}}
              onDelete={deleteDepartament}
              isSubmitting={isSubmiting}
            />

            <ModalEmploye/>
          </div>
        </div>
      </div>
    </>
  );
};
